import NotificationsOffSharpIcon from '@gamma/ui/icons/NotificationsOffSharpIcon';
import { i18n } from '../../../../shared/localization';

import { PillWrapper } from '.';

const { suppressSuccessTitle } = i18n.pages.entityDetails.excludeEntity;

export const EntitySuppressedPill = () => {
  return (
    <PillWrapper label={suppressSuccessTitle}>
      <NotificationsOffSharpIcon size="sm" />
    </PillWrapper>
  );
};
